'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _jsCookie = require('js-cookie');

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _EVENTS = require('./constants/EVENTS');

var _EVENTS2 = _interopRequireDefault(_EVENTS);

var _getDiffusionConfig = require('./getDiffusionConfig');

var _getDiffusionConfig2 = _interopRequireDefault(_getDiffusionConfig);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ScribbleWidgetInteracter = function () {
    function ScribbleWidgetInteracter() {
        (0, _classCallCheck3.default)(this, ScribbleWidgetInteracter);

        this.decimalOdds = false;
        this.diffusionConfig = {};

        this.target = document.querySelector('iframe[class*="scrbbl-embed"]').contentWindow;
        this.senderName = 'RP1 Main Window';
        this.trustedSenderDomain = 'embed.scribblelive.com';
        this.trustedSenderName = 'Scribble Live Blog widget iFrame';

        this.onPostMessage = this.onPostMessage.bind(this);
        this.onBetslipInitialized = this.onBetslipInitialized.bind(this);
        this.onBetslipBookmakerChanged = this.onBetslipBookmakerChanged.bind(this);
    }

    (0, _createClass3.default)(ScribbleWidgetInteracter, [{
        key: 'init',
        value: function init() {
            this.log('init()');

            var customizeSettingsCookie = _jsCookie2.default.get('customizeSettings');
            if (customizeSettingsCookie) {
                var customizeSettings = JSON.parse(customizeSettingsCookie);
                this.decimalOdds = customizeSettings.decimalOdds;
            }
            this.bindEvents();
            this.diffusionConfig = (0, _getDiffusionConfig2.default)();
            var segmentKey = document.querySelector('body').getAttribute('data-segment-key');
            this.sendPostMessage({
                eventName: _EVENTS2.default.SCRIBBLE_INITIALIZED,
                eventDetail: {
                    diffusionConfig: this.diffusionConfig,
                    segmentKey: segmentKey
                }
            });
        }
    }, {
        key: 'requestSelectedBookmaker',
        value: function requestSelectedBookmaker() {
            this.log('requestSelectedBookmaker()');

            // Trigger event for Betslip to broadcast current bookmaker via EVENTS.BETSLIP_BOOKMAKER
            var betslipEvent = new CustomEvent(_EVENTS2.default.BETSLIP_BOOKMAKER_GET);
            document.dispatchEvent(betslipEvent);
        }
    }, {
        key: 'onBetslipInitialized',
        value: function onBetslipInitialized() {
            this.log('onBetslipInitialized()');

            this.requestSelectedBookmaker();
        }
    }, {
        key: 'onBetslipBookmakerChanged',
        value: function onBetslipBookmakerChanged(_ref) {
            var eventName = _ref.type,
                detail = _ref.detail;

            this.log('onBetslipBookmakerChanged(', eventName, ',', detail, ')');

            this.sendPostMessage({
                eventName: eventName,
                eventDetail: (0, _assign2.default)(detail, {
                    decimalOdds: this.decimalOdds,
                    diffusionConfig: this.diffusionConfig
                })
            });
        }
    }, {
        key: 'sendPostMessage',
        value: function sendPostMessage(message) {
            this.log('sendPostMessage(', message, ')');

            this.target.postMessage((0, _assign2.default)(message, { sender: this.senderName }), '*');
        }
    }, {
        key: 'onPostMessage',
        value: function onPostMessage(_ref2) {
            var origin = _ref2.origin,
                _ref2$data = _ref2.data,
                sender = _ref2$data.sender,
                eventName = _ref2$data.eventName,
                eventDetail = _ref2$data.eventDetail;

            if (origin.includes(this.trustedSenderDomain) && sender === this.trustedSenderName) {
                this.log('[POST MESSAGE RECEIVED]:', eventName, eventDetail);

                switch (eventName) {
                    case _EVENTS2.default.SCRIBBLE_INITIALIZED:
                    case _EVENTS2.default.BETSLIP_BOOKMAKER_GET:
                        this.requestSelectedBookmaker();
                        break;

                    case _EVENTS2.default.BETSLIP_MAKE_SELECTION:
                        this.onMessageBetslipMakeSelection(eventDetail);
                        break;

                    default:
                        // No default action
                        break;
                }
            }
        }
    }, {
        key: 'onMessageBetslipMakeSelection',
        value: function onMessageBetslipMakeSelection(eventDetail) {
            this.log('onMessageBetslipMakeSelection(eventDetail:', eventDetail, ')');

            // Trigger event for Betslip to open selection
            var makeSelectionEvent = new CustomEvent(_EVENTS2.default.BETSLIP_MAKE_SELECTION, { detail: eventDetail });
            document.dispatchEvent(makeSelectionEvent);
        }
    }, {
        key: 'bindEvents',
        value: function bindEvents() {
            window.addEventListener(_EVENTS2.default.MESSAGE, this.onPostMessage, false);
            document.addEventListener(_EVENTS2.default.BETSLIP_INITIALIZED, this.onBetslipInitialized, false);
            document.addEventListener(_EVENTS2.default.BETSLIP_BOOKMAKER, this.onBetslipBookmakerChanged, false);
            document.addEventListener(_EVENTS2.default.BETSLIP_BOOKMAKER_CHANGED, this.onBetslipBookmakerChanged, false);
        }
    }, {
        key: 'destroy',
        value: function destroy() {
            window.removeEventListener(_EVENTS2.default.MESSAGE, this.onPostMessage, false);
            document.removeEventListener(_EVENTS2.default.BETSLIP_INITIALIZED, this.onBetslipInitialized, false);
            document.removeEventListener(_EVENTS2.default.BETSLIP_BOOKMAKER, this.onBetslipBookmakerChanged, false);
            document.removeEventListener(_EVENTS2.default.BETSLIP_BOOKMAKER_CHANGED, this.onBetslipBookmakerChanged, false);
        }
    }, {
        key: 'log',
        value: function log() {
            if (process.env.NODE_ENV !== 'production') {
                var _console;

                for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                    args[_key] = arguments[_key];
                }

                (_console = console).log.apply(_console, ['[MAIN] ' + this.constructor.name + ' ->'].concat(args));
            }
        }
    }]);
    return ScribbleWidgetInteracter;
}();

exports.default = ScribbleWidgetInteracter;


//////////////////
// WEBPACK FOOTER
// ./public/js/scribble/ScribbleWidgetInteracter.js
// module id = 710
// module chunks = 0